import React from "../_snowpack/pkg/react.js";
import {Demo} from "./Demo.js";
import {Intro} from "./Intro.js";
import {Explanation} from "./Explanation.js";
import {TopBar} from "./TopBar.js";
import {Api} from "./Api.js";
export const Layout = () => {
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(TopBar, null), /* @__PURE__ */ React.createElement("div", {
    className: "layout"
  }, /* @__PURE__ */ React.createElement(Intro, null), /* @__PURE__ */ React.createElement(Demo, null), /* @__PURE__ */ React.createElement(Explanation, null), /* @__PURE__ */ React.createElement(Api, null)));
};
